import React, { useState } from "react";
import { svgs } from "../assats";
import LeftRightEar from "../../components/LeftRightEar";
import { Treatment } from "../types/DeviceType";
import PatientCharts from "../../components/PatientCharts/PatientCharts";
import ClickableSVG from "../../components/ClickableSVG/ClickableSVG";
import { downloadReport } from "../api/treatmentService";

const ChartsWithModal = ({ treatmentId }: { treatmentId: string }) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {showModal && (
        <PatientCharts
          show={showModal}
          onHide={() => setShowModal(false)}
          treatmentId={treatmentId}
        />
      )}
      <ClickableSVG
        Icon={svgs.icons.Activity}
        buttonAction={() => setShowModal(true)}
        title="Show Treatment Charts"
      />
    </>
  );
};

export function organizePatientTreatments(data: Treatment[]) {
  return data?.map((val) => {
    const isDownloadable = !!val.treatmentEndTime;

    const subAction = async (): Promise<void> => {
      if (!isDownloadable) return;
      await downloadReport(val.id);
    };


    return {
      TreatmentDate: new Date(val.treatmentDate).toLocaleDateString() || "",
      TreatmentStartTime: new Date(val.treatmentStartTime).toLocaleTimeString() || "",
      TreatmentEndTime: val.treatmentEndTime
        ? new Date(val.treatmentEndTime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', second: '2-digit' })
        : "",
      ReportsTable: (
        <ClickableSVG
          Icon={svgs.icons.ReportTable}
          buttonAction={isDownloadable ? subAction : undefined}
          disabled={!isDownloadable}
          title={
            isDownloadable
              ? "Download treatment report"
              : "Treatment must be completed to download report"
          }
        />
      ),
      Charts: <ChartsWithModal treatmentId={val.id} />,
    };
  });
}
